import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const DeleteOrgModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteOrgModalContainer" */
      './DeleteOrgModalContainer'
    ),
  loading: LoadingModal,
});
